export default __webpack_public_path__ + "static/media/video_app_catalogo_web.e1724c02.mp4";